<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6"> </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessInfo",

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text:
          "Julibee Employment Pte Ltd. <br>46 East Coast Road, <br> #10-03,<br> EastGate Singapore 428766"
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+65 9784 9202 <br> +65 9145 5943"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "julibeeemployment@gmail.com"
      }
    ]
  })
};
</script>
